import React, { useState, useEffect } from 'react';
import PageHeading from '../components/common/PageHeading';
import { Helmet } from 'react-helmet';

function Gallery() {
  const BASE_URL = "https://oxfordcollege.lk/api/"
  const END_POINT = BASE_URL + "/routes/gallery.php?route=get";

  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState({});
  const [filter, setFilter] = useState("All");
  const [isLoading, setIsLoading] = useState(true);

  const fetchGalleryData = async () => {
    try {
      const categoryResponse = await fetch(`${END_POINT}&type=gallery_type`);
      const categoryData = await categoryResponse.json();
      setCategories([{ id: "All", name: "All" }, ...categoryData.data]);

      const imageResponse = await fetch(`${END_POINT}&type=gallery`);
      const imageData = await imageResponse.json();
      setImages(imageData.data);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGalleryData();
  }, []);

  const filteredImages =
    filter === "All"
      ? Object.values(images).flat()
      : images[filter] || [];

  return (
    <div className='w-full'>
      <Helmet>
        <title>Gallery - Oxford College</title>
        <meta name="description" content="Explore our gallery to see moments from Oxford College's events, achievements, and activities." />
        <meta name="keywords" content="Gallery, Photos, Events, Activities, Oxford College" />
        <meta name="author" content="Oxford College - Gampaha" />
        <meta property="og:title" content="Gallery - Oxford College - Gampaha" />
        <meta property="og:description" content="View the gallery showcasing memorable moments at Oxford College." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://oxfordcollege.lk/gallery" />
        <meta property="og:image" content="https://www.facebook.com/photo/?fbid=127196623392555&set=a.127196626725888" />
      </Helmet>

      <PageHeading title={'Gallery'} imgUrl={'./assets/images/gallery.webp'} alt={'Gallery'} />

      <div className='mt-10 sm:px-10 mx-auto container'>
        {isLoading ? (
          <div className="text-center text-lg">Loading...</div>
        ) : (
          <div className='w-full flex flex-col gap-y-4 mt-20'>
            <div className='flex gap-4 mt-4 justify-center items-center flex-wrap'>
              {categories.map((category) => (
                <span
                  key={category.id}
                  className={`cursor-pointer text-center text-tiny md:text-medium py-1 px-5 ${filter === category.id ? "text-black font-medium bg-neutral-200 rounded-lg" : "text-neutral-400"}`}
                  onClick={() => setFilter(category.id)}
                >
                  {category.name}
                </span>
              ))}
            </div>

            <div className="columns-2 md:columns-3 lg:columns-4 gap-0">
              {filteredImages.length > 0 ? (
                filteredImages.map((image, index) => (
                  <div key={index} className='w-full break-inside-avoid p-1'>
                    <img src={image} alt={`Gallery ${index}`} className="w-full shadow-sm" />
                  </div>
                ))
              ) : (
                <div className="text-center text-neutral-500">No images available for this category.</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Gallery;